/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Submission_NoneInputs */



/**
* | output |
* | --- |
* | "No decklist" |
*
* @param {Tournaments_Lib_Deck_Submission_NoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_submission_none = /** @type {((inputs?: Tournaments_Lib_Deck_Submission_NoneInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Submission_NoneInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Deckliste")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune decklist")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无需卡组表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("不需牌組清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("덱 목록 없음")
	return /** @type {LocalizedString} */ ("No decklist")
});